module.exports = __webpack_public_path__ + "9488d02b/img/chevron-right-icon.253a4260.svg";